import { render, staticRenderFns } from "./RegisterReportingPoint.vue?vue&type=template&id=d56b12cc&"
import script from "./RegisterReportingPoint.vue?vue&type=script&lang=js&"
export * from "./RegisterReportingPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports